import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getAgreements() {
  try {
    const agreements = yield call(API.getAgreements);
    yield put({
      type: actionTypes.AGREEMENTS_GET_SUCCESS,
      agreements,
    });
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENTS_GET_ERROR,
      error,
    });
  }
}

export function* getAgreement({ agreementId }) {
  try {
    const agreement = yield call(API.getAgreement, agreementId);
    if (agreement.id) {
      yield put({
        type: actionTypes.AGREEMENT_GET_SUCCESS,
        agreement,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_GET_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_GET_ERROR,
      error,
    });
  }
}

export function* createAgreement({ agreement }) {
  try {
    const result = yield call(API.createAgreement, agreement);
    if (result.error) {
      yield put({
        type: actionTypes.AGREEMENT_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_CREATE_SUCCESS,
        agreement: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_CREATE_ERROR,
      error,
    });
  }
}

export function* updateAgreement({ agreementId, agreement }) {
  try {
    const result = yield call(API.updateAgreement, agreementId, agreement);
    if (result.id) {
      yield put({
        type: actionTypes.AGREEMENT_UPDATE_SUCCESS,
        agreement: result,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_UPDATE_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_UPDATE_ERROR,
      error,
    });
  }
}

export function* deleteAgreement({ agreementId }) {
  try {
    yield call(API.deleteAgreement, agreementId);
    yield put({
      type: actionTypes.AGREEMENT_DELETE_SUCCESS,
      agreementId,
    });
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_DELETE_ERROR,
      error,
    });
  }
}

export function* getAgreementContractBlocks({ agreementId }) {
  try {
    const result = yield call(API.getAgreementContractBlocks, agreementId);
    if (result.error) {
      yield put({
        type: actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_SUCCESS,
        contractBlocks: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_ERROR,
      error,
    });
  }
}

export function* saveAgreementContractBlock({ contractBlock }) {
  try {
    const result = yield call(API.saveAgreementContractBlock, contractBlock);
    if (result.error) {
      yield put({
        type: actionTypes.AGREEMENT_CONTRACT_BLOCK_SAVE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_CONTRACT_BLOCK_SAVE_SUCCESS,
        contractBlock: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_CONTRACT_BLOCK_SAVE_ERROR,
      error,
    });
  }
}

export function* createAgreementSentence({ agreementSentence }) {
  try {
    const result = yield call(API.createAgreementSentence, agreementSentence);
    if (result.error) {
      yield put({
        type: actionTypes.AGREEMENT_SENTENCE_CREATE_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_SENTENCE_CREATE_SUCCESS,
        agreementSentence: result,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_SENTENCE_CREATE_ERROR,
      error,
    });
  }
}

export function* updateAgreementSentence({ id, agreementSentence }) {
  try {
    const result = yield call(
      API.updateAgreementSentence,
      id,
      agreementSentence
    );
    if (result.id) {
      yield put({
        type: actionTypes.AGREEMENT_SENTENCE_UPDATE_SUCCESS,
        agreementSentence: result,
      });
    } else {
      yield put({
        type: actionTypes.AGREEMENT_SENTENCE_UPDATE_ERROR,
      });
    }
  } catch (error) {
    yield put({
      type: actionTypes.AGREEMENT_SENTENCE_UPDATE_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/agreements.js